const styles = (theme) => ({
  tierSummary: {
    display: 'block',
    marginBottom: theme.spacing(1.5),
  },
  warning: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#FFF4E5',
    border: `1px solid ${theme.palette.warning.main}`,
  },
  warningText: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  list: {
    maxHeight: 280,
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  listItemLow: {
    backgroundColor: '#FFF8F6',
    borderLeft: `3px solid ${theme.palette.error.main}`,
  },
  courseBlock: {
    flex: 1,
    minWidth: 0,
  },
  courseName: {
    fontWeight: 500,
  },
});

export default styles;
